import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MailSidebar from './MailSidebar';
import MailSummaryPage from './MailSummaryPage';
import MailInboxPage from './MailInboxPage';
import MailAccountPage from './MailAccountPage';

const MailModuleLayout = () => {
  return (
    <div className="flex flex-1 min-h-0 min-w-0 w-full h-full bg-gray-50 dark:bg-gray-900">
      <MailSidebar />
      <div className="flex-1 min-w-0 min-h-0 flex flex-col overflow-y-auto">
        <Routes>
          <Route index element={<Navigate to="summary" replace />} />
          <Route path="summary" element={<MailSummaryPage />} />
          <Route path="inbox" element={<MailInboxPage />} />
          <Route path="account" element={<MailAccountPage />} />
          <Route path="*" element={<Navigate to="summary" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default MailModuleLayout;
